import { type MCPServerInfo } from '../../types';

const GoogleDriveOfficialServer: MCPServerInfo = {
  serverId: 'GOOGLE_DRIVE_OFFICIAL',
  name: 'Google Drive (Official)',
  slug: 'google-drive-v2',
  description:
    'Official Google-hosted Drive MCP Server for searching, reading, creating, and managing files and permissions',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://drivemcp.googleapis.com/mcp/v1',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleDriveOfficialServer;
